"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InputFieldsHelper = (function () {
    function InputFieldsHelper() {
    }
    InputFieldsHelper.setMaxInputLength = function (inputElement, value) {
        if (inputElement.value.length > value) {
            inputElement.value = inputElement.value.slice(0, value);
        }
    };
    InputFieldsHelper.setInputFilter = function (textbox, inputFilter) {
        ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].
            forEach(function (event) {
            textbox.addEventListener(event, function () {
                if (inputFilter(this.value)) {
                    this.oldValue = this.value;
                    this.oldSelectionStart = this.selectionStart;
                    this.oldSelectionEnd = this.selectionEnd;
                }
                else if (this.hasOwnProperty("oldValue")) {
                    this.value = this.oldValue;
                    this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
                }
            });
        });
    };
    return InputFieldsHelper;
}());
exports.default = InputFieldsHelper;



//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/ts/helpers/input-helper.ts
// module id = 1214
// module chunks = 0